import { gql } from "@apollo/client";

export const GET_MANAGEABLE_SECTIONS = gql`
  query GetManageableSections($input: BackofficeManageableSectionsInput!) {
    manageableSections(input: $input) {
      nodes {
        id
        name
        legacyId
      }
    }
  }
`;

export const CREATE_ACTIVITY_MUTATION = gql`
  mutation CreateActivity($input: BackofficeActivitiesCreateActivityInput!) {
    createActivity(input: $input) {
      success
      message
      activity {
        id
      }
    }
  }
`;

export const EDIT_ACTIVITY_MUTATION = gql`
  mutation EditActivity($input: BackofficeActivitiesEditActivityInput!) {
    editActivity(input: $input) {
      success
      message
      activity {
        id
      }
    }
  }
`;
